// src/components/GuideImageSingle.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function GuideImageSingle({
  // 画像パスと戻り先は必要に応じて差し替え可能
  src = '/images/LocationSetting.jpg',
  alt = 'guide image',
  backTo = '/tennouzu/guide',
}) {
  const navigate = useNavigate();
  const [loaded, setLoaded] = useState(false);
  const [error, setError]   = useState(false);

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: 20,
      maxWidth: '100%',
    }}>
      {/* 画像表示エリア */}
      <div style={{
        position: 'relative',
        marginBottom: 20,
        maxWidth: '100%',
        border: '1px solid #ddd',
        borderRadius: 8,
        overflow: 'hidden',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
      }}>
        {!loaded && !error && (
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: 400,
            backgroundColor: '#f5f5f5',
            color: '#666',
            padding: 20,
          }}>
            読み込み中…
          </div>
        )}

        {error && (
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: 400,
            backgroundColor: '#ffe6e6',
            color: '#d32f2f',
            padding: 20,
            textAlign: 'center',
            wordBreak: 'break-all',
          }}>
            画像の読み込みに失敗しました。<br />
            {src}
          </div>
        )}

        <img
          src={src}
          alt={alt}
          onLoad={() => { setLoaded(true); setError(false); }}
          onError={() => { setLoaded(false); setError(true); }}
          style={{
            maxWidth: '100%',
            height: 'auto',
            display: loaded && !error ? 'block' : 'none',
          }}
        />
      </div>

      {/* ボタン（これだけ） */}
      <button
        onClick={() => navigate(backTo)}
        style={{
          padding: '10px 20px',
          backgroundColor: '#007bff',
          color: '#fff',
          border: 'none',
          borderRadius: 6,
          cursor: 'pointer',
          fontSize: 16,
          fontWeight: 600,
        }}
        aria-label="ガイドへ戻る"
      >
        ガイドへ戻る
      </button>
    </div>
  );
}

export default GuideImageSingle;
